import React, { Component } from 'react';
import moment from 'moment';

class MachineTermsView extends Component {
    render() {
        return (
            <div>
                <b>
                    Location:&nbsp;
                </b>
                {this.props.location}
                <br />
                <b>
                    Brand:&nbsp;
                </b>
                {this.props.brand}
                <br />

                <b>
                    Model:&nbsp;
                </b>
                {this.props.model}
                <br />

                <b>
                    Serial/N:&nbsp;
                </b>
                {this.props.serial}
                <br />

                <b>
                    Year:&nbsp;
                </b>
                {this.props.year}
                <br />
                <b>
                    Last Check:&nbsp;
                </b>
                {moment().add(this.props.lastcheck, 'days').calendar()}
                {/* {moment()} */}
                <br />
            </div>
        );
    }
}

export default MachineTermsView;



// WEBPACK FOOTER //
// ./src/components/views/MachineTermsView.js